<template>
  <div class="grid-container grid-container--6-6">
    <select-autocomplete
      class="col1"
      placeholder="Ej: 11"
      label="Cód. de área *"
      maxlength="4"
      subhint="Ingresá el código de área sin el 0"
      v-model="value.area"
      name="area"
      :required="required"
      :items="codigosAreaPopulares"
      :validationError="validationError.area"
      @input="onInput"
    />
    <number-input
      class="col2"
      placeholder="Ej: 43464800"
      label="Número *"
      name="numero"
      maxlength="8"
      :subhint="subhint"
      v-model="value.numero"
      :required="required"
      :validationError="validationError.numero"
      @input="onInput"
    />
  </div>
</template>

<script>
import { codigosAreaPopulares } from "@/config/constants";
import NumberInput from "@/components/core/NumberInput";
import SelectAutocomplete from "@/components/core/custom/SelectAutocomplete";
export default {
  name: "PhoneNumber",
  components: { NumberInput, SelectAutocomplete },
  props: {
    subhint: {
      type: String,
      default: "Ingresá el número sin el 15"
    },
    label: String,
    value: Object
  },
  data() {
    return {
      validationError: { area: null, numero: null },
      checked: false
    };
  },
  methods: {
    onInput() {
      if (this.checked) {
        this.isValidNumber(this.value);
      }
    },

    checkValid() {
      this.checked = true;
      return this.isValidNumber(this.value);
    },
    isValidNumber(val) {
      let error = { area: true, numero: true };

      if (!isNaN(parseFloat(val.area)) && isFinite(val.area)) {
        if (val.area.length >= 2 && val.area.length <= 4) {
          // El valor es válido
          this.validationError.area = null;
          error.area = false;
        }
      }
      if (!isNaN(parseFloat(val.numero)) && isFinite(val.numero)) {
        if (val.numero.length >= 5 && val.numero.length <= 8) {
          // El valor es válido
          this.validationError.numero = null;
          error.numero = false;
        }
      }

      if (error.area) {
        this.validationError.area = "El código de área no es válido";
      }

      if (error.numero) {
        this.validationError.numero = "El número no es válido";
      }

      if (error.numero || error.area) {
        return false;
      }

      return true;
    }
  },
  computed: {
    codigosAreaPopulares() {
      return codigosAreaPopulares;
    }
  }
};
</script>

<style scoped></style>
